import script from "./QOrdersItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QOrdersItem.vue?vue&type=script&setup=true&lang=js"

import "./QOrdersItem.vue?vue&type=style&index=0&id=786a5e34&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786a5e34"]])

export default __exports__